import _extends from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import Slider from 'react-slick';
import { ArrowIcon } from "../../_global/Icons";
import { CardPrevArrowContainer, CardNextArrowContainer } from "../../OffersCarousel/style";
import { merchantProps } from "../Detail/merchantProps";
import { similarSettings } from "../Detail/merchantUtils";
import { OtherStores, StyledCardWrapper } from "../Style/index";
import Card from "../List/Card";
var OtherStoreSlider = /*#__PURE__*/function (_Component) {
  function OtherStoreSlider(props) {
    var _this;
    _classCallCheck(this, OtherStoreSlider);
    _this = _callSuper(this, OtherStoreSlider, [props]);
    _this.state = {
      activeSlide: 0
    };
    _this.next = _this.next.bind(_this);
    _this.previous = _this.previous.bind(_this);
    return _this;
  }
  _inherits(OtherStoreSlider, _Component);
  return _createClass(OtherStoreSlider, [{
    key: "next",
    value: function next() {
      this.slider.slickNext();
    }
  }, {
    key: "previous",
    value: function previous() {
      this.slider.slickPrev();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var merchant = this.props.merchant;
      similarSettings.beforeChange = function (current, next) {
        _this2.setState({
          activeSlide: next
        });
      };
      return __jsx(OtherStores, {
        wideView: true
      }, __jsx("p", null, "You may also like "), __jsx(StyledCardWrapper, null, this.state.activeSlide !== 0 && __jsx(CardPrevArrowContainer, {
        onClick: this.previous
      }, __jsx(ArrowIcon, {
        direction: "left"
      })), merchant.similarMerchants.length > 0 && __jsx(CardNextArrowContainer, {
        onClick: this.next
      }, __jsx(ArrowIcon, {
        direction: "right"
      })), __jsx(Slider, _extends({}, similarSettings, {
        ref: function ref(arg) {
          _this2.slider = arg;
        }
      }), merchant.similarMerchants.map(function (similar) {
        return __jsx(Card, {
          merchant: similar,
          key: similar.merchantId
        });
      }))));
    }
  }]);
}(Component);
export default OtherStoreSlider;